import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children }) {
  const { user } = useAuth();
  const location = useLocation();

  // Still resolving auth state — show nothing to avoid flash
  if (user === undefined) {
    return (
      <div className="min-h-screen bg-[#080E1E] flex items-center justify-center">
        <div className="w-8 h-8 border-2 border-[#2D5BE3] border-t-transparent rounded-full animate-spin" />
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
